var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        'button-close': true,
        'button-close_justify-center': _vm.isCenter,
        'button-close_justify-end': _vm.isEnd,
    }},[_c('CloseSVG',{staticClass:"button-close__image",attrs:{"height":_vm.height,"width":_vm.width},on:{"click":_vm.action}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }